import { useState, useCallback } from "react";
import { StripeEmbeddedCheckout } from "@/components/StripeEmbeddedCheckout";
import { RefundWaiver } from "@/components/workbooks/RefundWaiver";

interface CheckoutOptions {
  /** Single price lookup key, or several for a multi-item cart */
  priceId?: string;
  priceIds?: string[];
  customerEmail?: string;
  returnUrl?: string;
  title?: string;
}

export function useStripeCheckout() {
  const [options, setOptions] = useState<CheckoutOptions | null>(null);
  const [waiverAccepted, setWaiverAccepted] = useState(false);

  const openCheckout = useCallback((opts: CheckoutOptions) => {
    setWaiverAccepted(false);
    setOptions(opts);
  }, []);

  const closeCheckout = useCallback(() => {
    setOptions(null);
    setWaiverAccepted(false);
  }, []);

  const priceIds = options
    ? options.priceIds?.length
      ? options.priceIds
      : options.priceId
        ? [options.priceId]
        : []
    : [];

  const checkoutElement =
    options && priceIds.length ? (
      <div className="space-y-5">
        <RefundWaiver checked={waiverAccepted} onChange={setWaiverAccepted} />
        {waiverAccepted ? (
          <StripeEmbeddedCheckout
            priceIds={priceIds}
            customerEmail={options.customerEmail}
            returnUrl={options.returnUrl}
          />
        ) : (
          <p className="text-sm font-light text-muted-foreground">
            Tick the box above to open the payment window.
          </p>
        )}
      </div>
    ) : null;

  return {
    openCheckout,
    closeCheckout,
    isOpen: options !== null,
    checkoutTitle: options?.title,
    waiverAccepted,
    checkoutElement,
  };
}
